import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./Footer";
import LandingPage from "./LandingPage";
import AboutUs from "./AboutUs"; // ✅ Import your new page
import Services from "./Services";
import Portfolio from "./Portfolio";
import Contact from "./Contact";
import Management from "./Management";
import HomePage from "./HomePage";
import FeaturesShowcase from "./About1";
import WhyChoose from "./WhyChoose";  
import LoadingSpinner from "./components/LoadingSpinner";

// Utility to wait for all images to load in the document
function waitForAllImages() {
  const images = Array.from(document.images);
  if (images.length === 0) return Promise.resolve();
  return Promise.all(
    images.map(img =>
      img.complete && img.naturalWidth !== 0
        ? Promise.resolve()
        : new Promise(resolve => {
            img.addEventListener('load', resolve, { once: true });
            img.addEventListener('error', resolve, { once: true });
            // Fallback: resolve after 3s if image never loads
            setTimeout(resolve, 3000);
          })
    )
  );
}

function LandingPageWithLoading() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancelled = false;
    waitForAllImages().then(() => {
      if (!cancelled) setLoading(false);
    });
    return () => { cancelled = true; };
  }, []);
  if (loading) return <LoadingSpinner />;
  return <LandingPage />;
}

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<LandingPageWithLoading />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/management" element={<Management />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/names" element={<FeaturesShowcase />} />
        <Route path="/why-choose" element={<WhyChoose />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
